import { Button } from "@/components/ui/button";
import { Share2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { toast } from "sonner";

export const ShareButton: React.FC = () => {
	const handleCopy = async () => {
		await navigator.clipboard.writeText(window.location.href);
		toast.success("Link copied!", {
			description: "You can now share this link with others.",
		});
	};

	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<Button variant="outline" size="sm" onClick={handleCopy}>
						<Share2 className="h-3.5 w-3.5" />
					</Button>
				</TooltipTrigger>
				<TooltipContent side="top">Share this page</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};
